// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_2787e5dfdf--checkbox--E83MD","box":"_2787e5dfdf--box--TSmoe","invalid":"_2787e5dfdf--invalid--duKFV","disabled":"_2787e5dfdf--disabled--WW5p9"};